import { useMemo } from "react";
import { useAppSelector } from "../../../../../redux/store";
import { useProjetsByUserQuery } from "../../../../../utils/api/launchCampagn/projet.api";
import { useRetraitsQuery } from "../../../../../utils/api/retrait/retrait.api";
import { formatMontant } from "../../../../../utils/utils";

// Quatre chiffres, pas un graphique : chacun repond a une question unique du
// porteur. Le lisere colore est un accent, jamais le seul porteur de sens —
// chaque tuile est etiquetee. Orange = en attente (statut), le reste est
// neutre ou vert pour le montant sur lequel il peut agir.
const COULEURS = {
  collecte: "#021849",
  disponible: "#0FBF56",
  attente: "#f39c12",
  verse: "#6c757d",
};

const somme = (xs: any[], f: (x: any) => any) =>
  xs.reduce((acc, x) => acc + (parseFloat(String(f(x) ?? 0)) || 0), 0);

function ProjetsStats() {
  const userId = useAppSelector((s) => s.user.user?.id as number);
  const { data = { results: [] } } = useProjetsByUserQuery({ page: 1, id: userId });
  const { data: retraits = [] } = useRetraitsQuery({});

  const tuiles = useMemo(() => {
    const projets = (data as any)?.results || [];
    const enAttente = retraits.filter((r) =>
      ["demande", "approuve", "en_cours"].includes(r.statut)
    );
    const verses = retraits.filter((r) => r.statut === "verse");
    return [
      {
        label: "Collecté",
        valeur: somme(projets, (p) => p.funds),
        couleur: COULEURS.collecte,
        aide: "Total des contributions validées",
      },
      {
        label: "Disponible au retrait",
        valeur: somme(projets, (p) => p.montant_total_restant),
        couleur: COULEURS.disponible,
        aide: "Après déduction des retraits en cours",
      },
      {
        label: "Retraits en attente",
        valeur: somme(enAttente, (r) => r.montant),
        couleur: COULEURS.attente,
        aide: `${enAttente.length} demande(s) en traitement`,
      },
      {
        label: "Déjà versé",
        valeur: somme(verses, (r) => r.montant),
        couleur: COULEURS.verse,
        aide: `${verses.length} versement(s)`,
      },
    ];
  }, [data, retraits]);

  return (
    <div className="row g-3 mb-3">
      {tuiles.map((t) => (
        <div className="col-md-3 col-6" key={t.label}>
          <div
            style={{
              background: "#fff",
              borderLeft: `4px solid ${t.couleur}`,
              boxShadow: "0px 2px 10px rgba(0,0,0,0.06)",
              borderRadius: 4,
              padding: "14px 16px",
              height: "100%",
            }}
          >
            <div
              style={{
                fontSize: 12,
                color: "rgba(0,0,0,0.6)",
                fontFamily: "Poppins",
              }}
            >
              {t.label}
            </div>
            <div
              style={{
                fontWeight: 600,
                fontSize: 20,
                fontFamily: "Poppins",
                color: "#021849",
                margin: "4px 0 2px 0",
              }}
            >
              {formatMontant(t.valeur)}
            </div>
            <div style={{ fontSize: 11, color: "rgba(0,0,0,0.45)" }}>
              {t.aide}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProjetsStats;
